import React from 'react';

import { Alert, Button, Center, Flex, TFText, Tooltip, useDisclosure } from '@tf/ui';
import { fmt, T } from '@tf/utils';

import type { Attachment } from '../VerificationResultModal';
import { getIdenfyCheckResultMessage, VerificationResultModal } from '../VerificationResultModal';
import type { IdenfyResponse } from '../VerificationResultModal/types';

type Props = {
	state: 'COMPLETED' | 'FAILED' | 'LIMITED' | 'NEW';
	response?: IdenfyResponse;
	attachments?: Attachment[];
};

export const IdenfyLivenessCheckResult: React.FC<Props> = ({ state, response, attachments }) => {
	const verificationModal = useDisclosure();

	if (state === 'NEW') {
		return (
			<Alert>
				<TFText>Waiting for liveness check result</TFText>
			</Alert>
		);
	}

	T.assertNotNullish(response, 'response must be present for this state');

	const message = getIdenfyCheckResultMessage(response.status.overall);

	return (
		<>
			<VerificationResultModal
				response={response}
				attachments={attachments ?? []}
				isOpen={verificationModal.isOpen}
				onModalClose={verificationModal.close}
			/>

			<Alert
				icon={
					<Tooltip label={message.label} position="top-start" withArrow withinPortal>
						<Center>{message.icon}</Center>
					</Tooltip>
				}
				sx={({ colors }) => ({
					padding: '0.5rem',
					borderStyle: 'solid',
					borderWidth: 1,
					borderColor: colors.brand[1],
					color: `rgb(${message.baseColor})`,
					'& .trustform-Alert-wrapper': {
						alignItems: 'center',
					},
					'& .trustform-Alert-icon': {
						alignItems: 'center',
						width: '1.6rem',
					},
				})}
			>
				<Flex align={'center'} justify={'space-between'}>
					<TFText sx={{ fontSize: '.8rem' }}>
						{message.label}{' '}
						{response.finishTime
							? fmt.toDate(response.finishTime * 1000, { preset: 'full_date_with_time' })
							: null}
					</TFText>
					<Button sx={{ height: '20px' }} size="sm" variant="subtle" onClick={verificationModal.open}>
						{!verificationModal.isOpen ? 'Show details' : 'Hide details'}
					</Button>
				</Flex>
			</Alert>
		</>
	);
};
